import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import WhatsAppAdminButton from '../components/WhatsAppAdminButton';

const inputStyle = { width: '100%', background: 'var(--dark-3)', border: '1px solid rgba(201,168,76,0.2)', color: 'var(--text)', padding: '12px 16px', borderRadius: '4px', fontSize: '14px', outline: 'none' };

const ListerLoginPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) navigate('/lister-dashboard');
    });
  }, [navigate]);

  const handleSendLink = async () => {
    setError('');
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setLoading(true);
    const { error: otpError } = await supabase.auth.signInWithOtp({
      email,
      options: {
        shouldCreateUser: false, // login only — signing up happens on /lister-signup
        emailRedirectTo: `${window.location.origin}/lister-dashboard`,
      },
    });
    setLoading(false);
    if (otpError) {
      setError(otpError.message.includes('Signups not allowed')
        ? "We couldn't find an account for that email. Try signing up instead."
        : otpError.message);
      return;
    }
    setSent(true);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--dark)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'var(--dark-3)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '8px', padding: '48px', width: '100%', maxWidth: '400px' }}>
        {sent ? (
          <>
            <h1 className="serif" style={{ color: 'var(--gold)', fontSize: '26px', fontWeight: 300, marginBottom: '16px' }}>Check Your Email</h1>
            <p style={{ color: 'var(--text-muted)', fontSize: '14px', lineHeight: 1.6, marginBottom: '20px' }}>
              We've sent a magic link to <strong style={{ color: 'var(--text)' }}>{email}</strong>. Click it to log in — no password needed.
            </p>
            <button onClick={() => setSent(false)} className="btn-ghost" style={{ width: '100%' }}>
              Use a different email
            </button>
          </>
        ) : (
          <>
            <h1 className="serif" style={{ color: 'var(--gold)', fontSize: '28px', fontWeight: 300, marginBottom: '8px' }}>Lister Login</h1>
            <p style={{ color: 'var(--text-muted)', fontSize: '13px', marginBottom: '32px' }}>One Stop Shop — Approved Listers Only</p>

            <input type="email" placeholder="Email" value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSendLink()}
              style={{ ...inputStyle, marginBottom: '16px' }} />

            {error && <p style={{ color: '#f87171', fontSize: '13px', marginBottom: '16px' }}>{error}</p>}

            <button onClick={handleSendLink} className="btn-primary" style={{ width: '100%' }} disabled={loading}>
              {loading ? 'Sending...' : 'Send Magic Link'}
            </button>

            <p style={{ color: 'var(--text-muted)', fontSize: '12px', marginTop: '24px', textAlign: 'center', marginBottom: '24px' }}>
              Don't have an account? <Link to="/lister-signup" style={{ color: 'var(--gold)' }}>Sign up</Link>
            </p>

            <div style={{ borderTop: '1px solid rgba(201,168,76,0.15)', paddingTop: '20px' }}>
              <WhatsAppAdminButton />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ListerLoginPage;
